module.exports = __webpack_public_path__ + "img/42.1.20a451c3.jpg";